<template>
  <b-row>
    <b-col>
      <b-form-group :label="label" :label-for="fieldName">
        <Datepicker
          :id="fieldName"
          :placeholder="placeHolder"
          :required="required"
          v-model="localValue"
          :format="formattedDateFormat"
          :disabledDates="disabledDates"
          v-bind="$attrs"
        />
        <slot name="inputValidationErrors"></slot>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import Datepicker from "vuejs-datepicker";

const DEFAULT_DATE_FORMAT = "yyyy-MM-dd";

export default {
  props: {
    fieldName: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeHolder: {
      type: String,
      default: "",
      required: false
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    },
    min: {
      type: Date,
      default: null,
      required: false
    },
    max: {
      type: Date,
      default: null,
      required: false
    },
    maxFromToday: {
      year: {
        type: Number,
        required: false,
        default: 0
      },
      month: {
        type: Number,
        required: false,
        default: 0
      },
      day: {
        type: Number,
        required: false,
        default: 0
      },
      type: Object,
      required: false,
      default() {
        return null;
      }
    },
    minFromToday: {
      year: {
        type: Number,
        required: false,
        default: 0
      },
      month: {
        type: Number,
        required: false,
        default: 0
      },
      day: {
        type: Number,
        required: false,
        default: 0
      },
      type: Object,
      required: false,
      default() {
        return null;
      }
    },
    format: {
      type: String,
      default: DEFAULT_DATE_FORMAT,
      required: false
    },
    value: {
      type: Date,
      required: true,
      default() {
        return new Date();
      }
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    formattedDateFormat() {
      return this.format && this.format != ""
        ? this.format
        : DEFAULT_DATE_FORMAT;
    },
    calculatedMaxDate() {
      const TODAY = new Date();
      return this.calculateDate(TODAY, this.maxFromToday);
    },
    calculatedMinDate() {
      const TODAY = new Date();
      return this.calculateDate(TODAY, this.minFromToday);
    },
    from() {
      return this.calculatedMaxDate ?? this.max;
    },
    to() {
      return this.calculatedMinDate ?? this.min;
    },
    disabledDates() {
      return {
        to: this.to,
        from: this.from
      };
    }
  },
  methods: {
    calculateDate(dateToBeModified, dateModifier) {
      if (!dateModifier) return null;
      const day = dateModifier.day;
      const month = dateModifier.month;
      const year = dateModifier.year;

      if (day == 0 && month == 0 && year == 0) return dateToBeModified;

      let date = dateToBeModified;

      date.setFullYear(date.getFullYear() + year);
      date.setMonth(date.getMonth() + month);
      date.setDate(date.getDate() + day);
      return date;
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style lang="scss" scoped></style>
